import type { MarkerColor } from "../../misc/markerColors";
import { colorForKey } from "../../misc/markerColors";

export function providerColor(provider: { name: string }): MarkerColor {
  return colorForKey(provider.name);
}
